export type PrivilegeType =
  | 'ManageCourse'
  | 'ManageStudent'
  | 'ManageSettings'
  | 'ManageContent';

export type PrivilegeKey =
  | 'manage_courses'
  | 'manage_students'
  | 'manage_settings'
  | 'manage_content';

export interface RegisterModeratorDto {
  name: string;
  email: string;
  password: string;
  privileges: PrivilegeType[];
}

export interface UpdateModeratorDto {
  name: string;
  email: string;
  privileges: PrivilegeType[];
}

export interface ModeratorResponseDto {
  id: string;
  username: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  active: boolean;
  privileges: PrivilegeType[];
}

export interface ModeratorApiResponse<T = unknown> {
  success: boolean;
  message?: string | null;
  data?: T;
}

const privilegeToApi: Record<PrivilegeKey, PrivilegeType> = {
  manage_courses: 'ManageCourse',
  manage_students: 'ManageStudent',
  manage_settings: 'ManageSettings',
  manage_content: 'ManageContent',
};

const privilegeFromApi: Record<PrivilegeType, PrivilegeKey> = {
  ManageCourse: 'manage_courses',
  ManageStudent: 'manage_students',
  ManageSettings: 'manage_settings',
  ManageContent: 'manage_content',
};

export function toApiPrivileges(keys: PrivilegeKey[]): PrivilegeType[] {
  return keys.map((key) => privilegeToApi[key]);
}

export function fromApiPrivileges(privileges: string[] | PrivilegeType[] | null | undefined): PrivilegeKey[] {
  if (!privileges?.length) return [];
  return privileges
    .map((privilege) => privilegeFromApi[privilege as PrivilegeType])
    .filter(Boolean);
}

export function selectedPrivilegeKeys(
  privileges: Record<PrivilegeKey, boolean>
): PrivilegeKey[] {
  return (Object.keys(privileges) as PrivilegeKey[]).filter((key) => privileges[key]);
}
